import {getObjMaxValue, getObjMinValue, inheritPrototype, isDef} from '../util/util'
import echarts from 'echarts'
import Base from './base'
import constant from '../util/contant'
const defaultNum = constant.defaultNum

// 柱状图的配置
var BarShare = function (dataList, type) {
  Base.call(this)
  this.type = type
  if (dataList) {
    this.xList = isDef(dataList.xList) ? dataList.xList : []
    this.yList = isDef(dataList.yList) ? dataList.yList : []
    this.optionSet = isDef(dataList.optionSet) ? dataList.optionSet : {}
  } else {
    this.xList = []
    this.yList = []
    this.optionSet = {}
  }
  this.init()
}
inheritPrototype(BarShare, Base)
BarShare.prototype.init = function () {
  this.option.toolbox = this.getToolbox()
  this.option.grid = this.getGrid()
  this.option.tooltip = this.getTooltip()
  let axisPosition = isDef(this.optionSet.axisPosition) ? this.optionSet.axisPosition : 'vertical'
  let isShowDataZoom = isDef(this.optionSet.isShowDataZoom) ? this.optionSet.isShowDataZoom : false
  let x = []
  for (let item of this.xList) {
    if (isDef(item) && item.indexOf('_') > -1) {
      x.push(item.split('_', -1)[0])
    } else {
      x.push(item)
    }
  }
  let axiaArr = []
  this.option.series = this.getSeries(axiaArr)
  if (axisPosition == 'vertical') {
    let xaxis = this.getXAxis()
    xaxis[0].data = x
    // xaxis[0].data = this.xList
    this.option.xAxis = xaxis
    this.option.yAxis = this.getYAxis(axiaArr)
  } else {
    this.option.xAxis = this.getHorXAxis()
    let yAxis = this.getHorYAxis()
    yAxis.data = x
    this.option.yAxis = yAxis
  }

  this.option.legend = this.getLegend(this.option.series)
  if (isShowDataZoom && this.xList.length > defaultNum) {
    this.option.dataZoom = this.getDataZoom()
  }
}
BarShare.prototype.getSeries = function (axiaArr) {
  let labelPosition = this.optionSet.labelPosition
  let labelColor = this.optionSet.labelColor
  let barWidth = this.optionSet.barWidth
  let series = []
  let max = 100
  let min = 0
  let axisArrMaxArr =[];
  let axisArrMinArr =[];
  let barBorderRadius=isDef(this.optionSet.barBorderRadius) ? this.optionSet.barBorderRadius : 2;
  if (this.yList) {
    for (let item in this.yList) {
      axisArrMinArr.push(getObjMinValue(this.yList[item].data));
      axisArrMaxArr.push(getObjMaxValue(this.yList[item].data));
      let serie = {
        type: 'bar',
        name: this.yList[item].name,
        barWidth: isDef(barWidth) ? barWidth : '16',
        barGap:'10',
        stack: isDef(this.yList[item].stack) ? this.yList[item].stack : '',
        data: this.yList[item].data,
        label: {
          normal: {
            show: isDef(this.yList[item].labelShow) ? this.yList[item].labelShow:false,
            position:isDef(this.yList[item].labelPosition) ? this.yList[item].labelPosition : 'top',
          }
        },
        itemStyle: {
          normal: {
            'barBorderRadius':barBorderRadius,
            color: isDef(this.yList[item].color) && this.yList[item].color.length > 0
              ? new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  {offset: 0, color: this.yList[item].color[0]},
                  {offset: 1, color: this.yList[item].color[1]}
                ])
              : '',
          }
        }
      }
      if (isDef(this.yList[item].stack)) {
        serie.label = {
          normal: {
            show: false,
            position: isDef(labelPosition) ? labelPosition : 'top',
            color: isDef(labelColor) ? labelColor : '#fff'
          }
        }
      }
      max = getObjMaxValue(axisArrMaxArr)
      min = getObjMinValue(axisArrMinArr)
      axiaArr[0] = min
      axiaArr[1] = max
      series.push(serie)
    }
    return series
  }
}

export default BarShare
